import React from "react";
import { InventoryGroupContent } from "../../content/inventoryGroup/inventoryGroupList";
import { Layout } from "../../layout/page";

export function InventoryGroup() {
  return (
    <Layout>
      <InventoryGroupContent />
    </Layout>
  );
}
